/***** Begin bsFreeTextCarousel Scripts *****/

var bsFreeTextCarousel = {


  init: function(panelsToDisplay, carouselId)
  {

    $('#' + carouselId + ' .carousel-inner').slick({
      accessibility: true,
      appendDots: $('#' + carouselId + ' .carousel-indicators'),
      autoplay: false,
      autoplaySpeed: 2500,
      dots: true,
      focusOnSelect: true,
      infinite: true,
      lazyLoad: 'ondemand',
      nextArrow: $('#' + carouselId + ' .right.carousel-control'),
      prevArrow: $('#' + carouselId + ' .left.carousel-control'),
      slidesToScroll: panelsToDisplay,
      slidesToShow: panelsToDisplay,
      speed: 500,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1
          }
        }
      ]
    });

    if ((navigator.userAgent.indexOf('Safari') != -1) && (navigator.userAgent.indexOf('Chrome') == -1))
    {
        $('.bsFreeTextCarousel carousel-control').css('display', '-webkit-inline-box');
    }
  }

};

/***** End bsFreeTextCarousel Scripts *****/